import React, { forwardRef } from 'react';
import ReactSelect, { Props as BaseProps } from 'react-select';
import { SelectSC, selectUnderlineStyles, selectBorderStyles } from './select.styled';

type FilteredBaseProps = Omit<BaseProps, 'isMulti'>;

export interface SelectProps extends FilteredBaseProps {
  variation: 'lined' | 'round';
  error?: boolean;
  prefix?: React.ReactNode;
  style: React.CSSProperties;
  isMulti?: boolean;
  label?: string;
}

const Select = (
  { variation, styles, style, label, alignment, ...rest }: SelectProps,
  ref?: React.Ref<ReactSelect>,
) => {
  const selectStyle = React.useMemo(
    () => (variation === 'lined' ? selectUnderlineStyles(styles) : selectBorderStyles(styles)),
    [variation, styles],
  );

  return (
    <SelectSC style={style as any} variation={variation}>
      {rest.prefix && rest.prefix}
      <ReactSelect
        ref={ref}
        {...rest}
        className="ui-select"
        classNamePrefix="ui-react-select"
        styles={selectStyle}
      ></ReactSelect>
    </SelectSC>
  );
};

export default forwardRef(Select);
